import LottoNav from "../LottoNav";
import {lotto5DMenus} from "../../constants/nav";
import React from "react";


const Lotto5DNav = () => <LottoNav menus={lotto5DMenus}/>

export default Lotto5DNav;